<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }" [template]="customLoadingTemplate"> </ngx-loading>
<ng-template #customLoadingTemplate></ng-template>
<div class="modal-lg">
    <div class="modal-header">
      <div class="modal-wizard-label">
        <div class="modal-wizard-title">Logo de Empresa</div>
        <div class="modal-wizard-desc">
          Agregue una imagen para utilizar como logo en la empresa seleccionada
        </div>
      </div>
    </div>
    <div class="modal-body">
      <!-- Se reutiliza el componente que ya tienes para cargar el logo -->
      <app-logo-emisor-entry 
        [relatedEmisor]="relatedEmisor" 
        [currentLogoEmisor]="currentLogoEmisor"
        (sendlogoEmisorRequest)="handleLogoRequest($event)" 
        (sendCloseRequestEmitter)="closeModal()">
      </app-logo-emisor-entry>
    </div>
  </div>
  